// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/service/destination_service.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import { file_proto_model_trip_destination } from "../model/trip/destination_pb";
import { file_proto_model_system_errors } from "../model/system/errors_pb";
import { file_proto_model_core_model_path } from "../model/core/model_path_pb";

/**
 * Describes the file proto/service/destination_service.proto.
 */
export const file_proto_service_destination_service = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_field_mask, file_proto_model_trip_destination, file_proto_model_system_errors, file_proto_model_core_model_path]);

/**
 * Describes the message carmen.CreateDestinationRequest.
 * Use `create(CreateDestinationRequestSchema)` to create a new message.
 */
export const CreateDestinationRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_destination_service, 0);

/**
 * Describes the message carmen.CreateDestinationResponse.
 * Use `create(CreateDestinationResponseSchema)` to create a new message.
 */
export const CreateDestinationResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_destination_service, 1);

/**
 * Describes the message carmen.GetDestinationRequest.
 * Use `create(GetDestinationRequestSchema)` to create a new message.
 */
export const GetDestinationRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_destination_service, 2);

/**
 * Describes the message carmen.GetDestinationResponse.
 * Use `create(GetDestinationResponseSchema)` to create a new message.
 */
export const GetDestinationResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_destination_service, 3);

/**
 * Describes the message carmen.ListDestinationsRequest.
 * Use `create(ListDestinationsRequestSchema)` to create a new message.
 */
export const ListDestinationsRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_destination_service, 4);

/**
 * Describes the message carmen.ListDestinationsResponse.
 * Use `create(ListDestinationsResponseSchema)` to create a new message.
 */
export const ListDestinationsResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_destination_service, 5);

/**
 * Describes the message carmen.UpdateDestinationRequest.
 * Use `create(UpdateDestinationRequestSchema)` to create a new message.
 */
export const UpdateDestinationRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_destination_service, 6);

/**
 * Describes the message carmen.UpdateDestinationResponse.
 * Use `create(UpdateDestinationResponseSchema)` to create a new message.
 */
export const UpdateDestinationResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_destination_service, 7);

/**
 * Describes the message carmen.DeleteDestinationRequest.
 * Use `create(DeleteDestinationRequestSchema)` to create a new message.
 */
export const DeleteDestinationRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_destination_service, 8);

/**
 * Describes the message carmen.DeleteDestinationResponse.
 * Use `create(DeleteDestinationResponseSchema)` to create a new message.
 */
export const DeleteDestinationResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_destination_service, 9);

/**
 * Service for managing destinations within trips
 *
 * @generated from service carmen.DestinationService
 */
export const DestinationService = /*@__PURE__*/
  serviceDesc(file_proto_service_destination_service, 0);

